// extracted by mini-css-extract-plugin
module.exports = {"jp":"jp-13JIM9ti"};